/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Blocklist_UpdatedInputs */

const en_carrier_blocklist_updated = /** @type {(inputs: Carrier_Blocklist_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrier blocklist updated`)
};

const es_carrier_blocklist_updated = /** @type {(inputs: Carrier_Blocklist_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de bloqueo de transportistas actualizada`)
};

/**
* | output |
* | --- |
* | "Carrier blocklist updated" |
*
* @param {Carrier_Blocklist_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_blocklist_updated = /** @type {((inputs?: Carrier_Blocklist_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Blocklist_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_blocklist_updated(inputs)
	return es_carrier_blocklist_updated(inputs)
});